import {
  GET_VENDOR,
  GET_VENDOR_SUCCESS,
  GET_VENDOR_FAIL,
  DELETE_VENDOR,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAIL,
  UPDATE_VENDOR,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_FAIL,
  ADD_NEW_VENDOR,
  ADD_VENDOR_SUCCESS,
  ADD_VENDOR_FAIL,
  VENDOR_LOADING,
  VENDOR_RESET,
  VENDOR_RESET_CREATE
} from "./actionType";

export const resetVendorState = (actionType) => ({
  type: VENDOR_RESET,
  payload: { actionType },
});


export const resetVendorCreateState = (actionType) => ({
  type: VENDOR_RESET_CREATE,
  payload: { actionType }
});

export const getVendorSuccess = (actionType, data) => ({
  type: GET_VENDOR_SUCCESS,
  payload: { actionType, data },
});

export const getVendorFail = (actionType, error) => ({
  type: GET_VENDOR_FAIL,
  payload: { actionType, error },
});

export const getVendor = data => ({
  type: GET_VENDOR,
  payload: data,
});

export const getVendorLoading = () => ({
  type: VENDOR_LOADING
});

export const deleteVendor = data => ({
  type: DELETE_VENDOR,
  payload: data,
});

export const deleteVendorSuccess = data => ({
  type: DELETE_VENDOR_SUCCESS,
  payload: data,
});

export const deleteVendorFail = error => ({
  type: DELETE_VENDOR_FAIL,
  payload: error,
});

export const updateVendor = data => ({
  type: UPDATE_VENDOR,
  payload: data,
});

export const updateVendorFail = error => ({
  type: UPDATE_VENDOR_FAIL,
  payload: error,
});

export const updateVendorSuccess = data => ({
  type: UPDATE_VENDOR_SUCCESS,
  payload: data,
});

export const addNewVendor = data => ({
  type: ADD_NEW_VENDOR,
  payload: data,
});

export const addVendorSuccess = data => ({
  type: ADD_VENDOR_SUCCESS,
  payload: data,
});

export const addVendorFail = error => ({
  type: ADD_VENDOR_FAIL,
  payload: error,
});